import types from "./types";

const INITIAL_STATE = {
  crm: null,
  crmError: null,
  crmLoading: false,

  //create
  createcrm: null,
  createcrmError: null,
  createcrmLoading: false,

  //update
  updatecrm: null,
  updatecrmError: null,
  updatecrmLoading: false,

  //delete
  deletecrm: null,
  deletecrmError: null,
  deletecrmLoading: false,

  //single item

  singleItem: null,
};

const ReagentReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_CRM_START:
      return {
        ...state,
        crm: null,
        crmError: null,
        crmLoading: true,
      };
    case types.GET_CRM_SUCCESS:
      return {
        ...state,
        crm: action.payload,
        crmLoading: false,
      };
    case types.GET_CRM_ERROR:
      return {
        ...state,
        crmError: action.payload,
        crmLoading: false,
      };
    case types.GET_CRM_RESET:
      return {
        ...state,
        crmError: null,
        crmLoading: false,
      };
    //create

    case types.CREATE_CRM_START:
      return {
        ...state,
        createcrm: null,
        createcrmError: null,
        createcrmLoading: true,
      };
    case types.CREATE_CRM_SUCCESS:
      return {
        ...state,
        createcrm: action.payload,
        createcrmLoading: false,
      };
    case types.CREATE_CRM_ERROR:
      return {
        ...state,
        createcrmError: action.payload,
        createcrmLoading: false,
      };
    case types.CREATE_CRM_RESET:
      return {
        ...state,
        createcrmError: null,
        createcrmLoading: false,
      };
    //delete

    case types.DELETE_CRM_START:
      return {
        ...state,
        deletecrm: null,
        deletecrmError: null,
        deletecrmLoading: true,
      };
    case types.DELETE_CRM_SUCCESS:
      return {
        ...state,
        deletecrm: action.payload,
        deletecrmLoading: false,
      };
    case types.DELETE_CRM_ERROR:
      return {
        ...state,
        deletecrmError: action.payload,
        deletecrmLoading: false,
      };
    case types.DELETE_CRM_RESET:
      return {
        ...state,
        deletecrm: null,
        deletecrmError: null,
        deletecrmLoading: false,
      };

    //update
    case types.UPDATE_CRM_START:
      return {
        ...state,
        updatecrm: null,
        updatecrmError: null,
        updatecrmLoading: true,
      };
    case types.UPDATE_CRM_SUCCESS:
      return {
        ...state,
        updatecrm: action.payload,
        updatecrmLoading: false,
      };
    case types.UPDATE_CRM_ERROR:
      return {
        ...state,
        updatecrmError: action.payload,
        updatecrmLoading: false,
      };
    case types.UPDATE_CRM_RESET:
      return {
        ...state,
        updatecrm: null,
        updatecrmError: null,
        updatecrmLoading: false,
      };
    //singleItem
    // case types.SINGLE_CRM_START:
    // 	return {
    // 		...state,
    // 		updatecrm: null,
    // 		updatecrmError: null,
    // 		updatecrmLoading: true,
    // 	};
    // case types.SINGLE_CRM_SUCCESS:
    // 	return {
    // 		...state,
    // 		updatecrm: action.payload,
    // 		updatecrmLoading: false,
    // 	};
    // case types.SINGLE_CRM_ERROR:
    // 	return {
    // 		...state,
    // 		updatecrmError: action.payload,
    // 		updatecrmLoading: false,
    // 	};
    // case types.SINGLE_CRM_RESET:
    // 	return {
    // 		...state,
    // 		updatecrmError: null,
    // 		updatecrmLoading: false,
    // 	};

    default:
      return { ...state };
  }
};

export default ReagentReducer;
